<template>
  <SeoBlogArticle :content="$t('seoArticleOQueEUtmMedium')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleOQueEUtmMedium',
  components: { SeoBlogArticle },
}
</script>
